import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
import { Box, IconButton } from '@mui/material';
import React from 'react';
import { HeadCell } from '../../../models/headCell';
import ViewTableColumns from './ViewTableColumns';

interface Props {
  viewTableColumnsProps: {
    columns: HeadCell[];
    onColumnClick: (
      column: HeadCell
    ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  };
  onFilter?: () => void;
  onSearch?: () => void;
  onExport?: () => void;
  toolbarAction?: React.ReactNode;
  children?: React.ReactNode;
}

const TableToolbar = (props: Props): JSX.Element => {
  const {
    viewTableColumnsProps,
    onFilter,
    onSearch,
    onExport,
    toolbarAction,
    children
  } = props;

  return (
    <Box sx={{ minHeight: '64px', p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'end' }}>
        {toolbarAction}
        {onSearch && (
          <IconButton onClick={() => onSearch()}>
            <SearchIcon />
          </IconButton>
        )}
        {onExport && (
          <IconButton onClick={() => onExport()}>
            <CloudDownloadIcon />
          </IconButton>
        )}
        {viewTableColumnsProps && (
          <ViewTableColumns {...viewTableColumnsProps} />
        )}
        {onFilter && (
          <IconButton onClick={() => onFilter()}>
            <FilterAltIcon />
          </IconButton>
        )}
      </Box>
      <Box p={2}>{children}</Box>
    </Box>
  );
};

export default TableToolbar;
